import { forwardRef } from 'react';
import { SnackbarContent, CustomContentProps } from 'notistack';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import styled from '@emotion/styled';
import PolarisIcon from './PolarisIcon';

const LoadingSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(({ id, ...props }, ref) => {
  return (
    <StyledSnackbarContent ref={ref}>
      <SnackbarContentCard>
        <SnackbarCardActions>
          <PolarisIcon icon="loading" height={25} width={25} />
          <span>{props.message}</span>
        </SnackbarCardActions>
      </SnackbarContentCard>
    </StyledSnackbarContent>
  );
});

const StyledSnackbarContent = styled(SnackbarContent)`
  & > .MuiPaper-root {
    border-radius: 23px;
  }
  height: 53px;
`;

const SnackbarContentCard = styled(Card)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  width: 100%;
  padding: 0 10px;
  color: #fff;
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  overflow: hidden;
`;

const SnackbarCardActions = styled(CardActions)`
  height: 53px;
`;

LoadingSnackbar.displayName = 'ReleaseNotes';

export default LoadingSnackbar;
